module.exports = __webpack_public_path__ + "static/jap-09325b9c82072d1389338a4b9c41db9a.png";